export enum vuei18nDayjsLocaleMap {
  rs = "sr",
  en = "en",
  mk = "mk"
}

export interface Favorite {
  isFavorite: boolean;
}

export interface AuthCredentials {
  token: string;
  deviceId: string;
}
